import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-25 border-0 rounded-0 bg-white stats-box",
  style: {"min-height":"205px"}
}
const _hoisted_2 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "title ms-15" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total de jugadores ", -1)
const _hoisted_6 = { class: "fw-black mb-8 lh-1 mt-30" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.totalPlayers), 1)
        ])
      ])
    ])
  ]))
}